import { render, staticRenderFns } from "./logo-main.svg?vue&type=template&id=0a7ed6e0&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/geofflevy/geofflevy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a7ed6e0', component.options)
    } else {
      api.reload('0a7ed6e0', component.options)
    }
    module.hot.accept("./logo-main.svg?vue&type=template&id=0a7ed6e0&", function () {
      api.rerender('0a7ed6e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/images/logo-main.svg"
export default component.exports